import React from "react";
import BaseModal from "../theme/modals/BaseModal";
import Input from "../theme/forms/Input";
import { connect } from "react-redux";
import { setGroups, setLoginFailure } from "../../store/actions";
import { login, pullCampaigns, pullGroups } from "../../store/api/calls";
import MFASetUpForm from "../subscreens/MFASetUpForm";

class LoginScreen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: null,
      password: null,
      mfacode: null,
      mfaForm: false,
      mfaError: null,
      disabled: false,
      mfaSetUp: false,
    };

    this.defaultFormInputs = [
      {
        type: "text",
        title: "username",
        dataKey: "username",
        placeholder: "",
        autofocus:true,
        id: "username-input",
        value: this.state.username,
        onChange: (val) => this.setState({ username: val }),
      },
      {
        type: "password",
        title: "password",
        dataKey: "password",
        placeholder: "",
        value: this.state.password,
        onChange: (val) => this.setState({ password: val }),
      },
    ];

    this.mfaFormInputs = [
      {
        type: "Code",
        title: "Enter MFA Code",
        dataKey: "mfacode",
        placeholder: "",
        value: this.state.mfacode,
        onChange: (val) => this.setState({ mfacode: val }),
      },
    ];
  }

  componentDidMount() {
    this.props.setLoginFailure(false);
  }

  doLogin = (hideMFACode = false) => {
    if (this.state.mfaForm && !this.state.mfacode) return;
    this.setState({ disabled: true });
    login({
      username: this.state.username,
      password: this.state.password,
      otp: hideMFACode ? null : this.state.mfacode,
    }).then((res) => {
      console.log(res);
      if (res && res.mfa) {
        this.setState({ mfaForm: true, disabled: false, mfacode: null });
        return;
      }

      if (res && res.mfa_setup_required) {
        this.setState({ mfaSetUp: true, disabled: false });
        return;
      }

      if (!this.props.loginFailure) {
        this.onLoginSuccess();
      } else {
        this.setState({ disabled: false });
      }
    });
  };

  onLoginSuccess = () => {
    Promise.all([pullGroups(), pullCampaigns()]).then(() => {
      this.props.history.push("/select-campaign");
    });
  };

  render() {
    return (
      <div className="login-wrapper">
        <div className="top-logo no-select">
          <img
            src={"/logo-full192.png"}
            alt={"ElecTrek"}
            className={"shadow"}
          />
        </div>

        <div className="card wox-card login-form">
          {!this.state.mfaForm && (
            <form
              onSubmit={(ev) => {
                ev.preventDefault();
                this.doLogin(true);
              }}
            >
              {this.defaultFormInputs.map((d) => (
                <Input {...d} key={d.title} />
              ))}
              <button
                type="submit"
                className="login-button"
                disabled={this.state.disabled}
              >
                Login
              </button>
              {/*{this.state.mfaForm && <a className='resend-link' onClick={() => this.doLogin(true)}>Resend Code</a>}*/}
            </form>
          )}

          {this.state.mfaForm && (
            <form
              onSubmit={(ev) => {
                ev.preventDefault();
                this.doLogin(false);
              }}
            >
              {this.mfaFormInputs.map((d) => (
                <Input {...d} />
              ))}
              <button
                type="submit"
                className="login-button"
                disabled={this.state.disabled}
              >
                Login
              </button>
            </form>
          )}
        </div>
        <div>
          {this.props.loginFailure && (
            <p className="login-error">
              <span className="fas fa-bomb" /> {this.props.loginFailure}
            </p>
          )}
        </div>

        {this.state.mfaSetUp && (
          <BaseModal
            open={true}
            onClose={() =>
              this.setState({ mfaSetUp: false, password: null, mfacode: null })
            }
            center
          >
            <MFASetUpForm
              title={"Your admin has required you to set up MFA."}
              dispatchProfileChanges={() => null} //no need since we don't display that info on the login page
              dismissModal={() =>
                this.setState({
                  mfaSetUp: false,
                  password: null,
                  mfacode: null,
                })
              }
              onSetUpSucess={() => setTimeout(this.onLoginSuccess, 500)}
            />
          </BaseModal>
        )}

        <div>&nbsp;</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  refreshToken: state.session.refreshToken,
  accessToken: state.session.accessToken,
  loginFailure: state.session.loginFailure,
  tokensInvalid: state.session.tokensInvalid,
});

const mapDispatchToProps = (dispatch) => ({
  setGroups: (groups) => dispatch(setGroups(groups)),
  setLoginFailure: (msg) => dispatch(setLoginFailure(msg)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginScreen);
